export default class ExportTracking {
  public constructor (init?:Partial<ExportTracking>) {
    Object.assign(this, init)
  }

  public date: string | null = null;
  public client: string | null = null;
  public task: string | null = null;
  public started: string | null = null;
  public stopped: string | null = null;
  public time: number | null = null;
  public total: number | null = null;
}
